import React, {useState} from "react";
import {Alert, Col, Input, Label, Row, Spinner} from "reactstrap";
import QButton from "../../../../common/components/QButton";
import {useTranslation} from "react-i18next";

interface Props {
    open: number | boolean, // open > 0 show
    setOpen: Function,
    callIntegration: Function,
    progress: number,
    showForceImport?:boolean
    /** Defaults to invoice copy; use "payout" for po_ force-import. */
    forceImportKind?: 'invoice' | 'payout'
}

const BodyModalIntegrationComponent: React.FC<Props> = ({
    showForceImport = false,
    forceImportKind = 'invoice',
    progress,
    setOpen,
    open,
    callIntegration,
    ...props
}) => {
    const {t} = useTranslation();
    const [isExpanded, setIsExpanded] = useState(false);
    const [startDate, setStartDate] = useState<string>('');
    const [endDate, setEndDate] = useState<string>('');
    const [forceImport, setForceImport] = useState<boolean>(false);
    const [stripeReference, setStripeReference] = useState<string>('');
    const synchronizing = progress > 0 && progress < 100;
    const referencePlaceholder = forceImportKind === 'payout'
        ? t("log.force_import_payout_placeholder")
        : t("log.force_import_reference_placeholder");
    const referenceHelp = forceImportKind === 'payout'
        ? t("log.force_import_payout_help")
        : t("log.force_import_reference_help");
    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    const handleSubmit = async () => {
        if (progress === 0 && !synchronizing) {
            await callIntegration({
                startDate,
                endDate,
                forceImport,
                reference: stripeReference.trim() || undefined,
            });
        } else if (progress === 100) {
            setOpen(false);
        }

    }
    return (
        <React.Fragment>
            <Row>
                <Col>
                    {synchronizing && (
                        <Alert color="info" className="d-flex align-items-center gap-2">
                            <Spinner size="sm"/>
                            <span>{t("log.synchronizing")}</span>
                        </Alert>
                    )}
                    {progress === 100 && <Alert color="success">{t("log.sync_done")}</Alert>}

                    {showForceImport && (
                        <div className="mb-3">
                            <Label>{t("log.force_import_reference")}</Label>
                            <Input
                                type="text"
                                className={'form-control-zp'}
                                placeholder={referencePlaceholder}
                                value={stripeReference}
                                disabled={synchronizing}
                                onChange={(e) => setStripeReference(e.target.value)}
                            />
                            <small className="text-muted d-block mt-1">{referenceHelp}</small>
                        </div>
                    )}

                    <div className={`slide-down-container ${isExpanded ? 'expanded' : ''}`}>
                        <div className="mb-3">
                            <Label>{t("log.start_date")}</Label>
                            <Input
                                type="datetime-local"
                                className={'form-control-zp'}
                                value={startDate}
                                disabled={synchronizing || Boolean(stripeReference.trim())}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </div>
                        <div className="mb-3">
                            <Label>{t("log.end_date")}</Label>
                            <Input
                                type="datetime-local"
                                className={'form-control-zp'}
                                value={endDate}
                                disabled={synchronizing || Boolean(stripeReference.trim())}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </div>

                        {showForceImport && (
                            <div className="mb-3">
                                <Label>{t("log.force_import")}</Label>
                                <Input
                                    style={{marginLeft:'10px'}}
                                    type="checkbox"
                                    className={'form-control-zp'}
                                    checked={forceImport}
                                    disabled={synchronizing || Boolean(stripeReference.trim())}
                                    onChange={(e) => setForceImport(e.target.checked)}
                                />
                            </div>
                        )}
                    </div>


                    <div className={'text-end'}>
                        <QButton
                            type="secondary"
                            onClick={toggleExpand}
                            content={isExpanded ? t("log.hide_advanced") : t("log.show_advanced")}
                            disabled={synchronizing}
                        />
                        <QButton
                            type={(progress === 0 ? 'primary' : 'success')}
                            onClick={handleSubmit}
                            content={synchronizing ? t("log.synchronizing") : (progress === 100 ? t("common.button.close") : t("common.button.submit"))}
                            disabled={synchronizing}
                        />
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default BodyModalIntegrationComponent
